import store from "@/store";
import {
  ZITADEL_ROLE_EMPLOYEE,
  ZITADEL_ROLE_FREELANCER,
  CLIENT_ADMIN,
  CLIENT_PROJECT_MANAGER,
  CLIENT_VIEWER,
} from "@/constants/roles";

export const ANONYMOUS = "ANONYMOUS";
export const FRONTEND_ONLY_DEMO = "FRONTEND_ONLY_DEMO";

export const Permission = {
  View_Objects: "View_Objects",
  View_PersonalSettings: "View_PersonalSettings",
  Create_Objects: "Create_Objects",
  Update_Objects: "Update_Objects",
  View_Measure: "View_Measure",
  View_Gallery: "View_Gallery",
  View_Solar: "View_Solar",
};

const CLIENT_VIEWER_PERMISSION = [
  Permission.View_Objects,
  Permission.View_PersonalSettings,
  Permission.View_Measure,
  Permission.View_Solar
];

const FULL_EDIT = [
  ...CLIENT_VIEWER_PERMISSION,
  Permission.Create_Objects,
  Permission.Update_Objects,
  Permission.View_Solar,
  Permission.View_Gallery,
  Permission.View_Measure,
];

export const RolePermissions = {
  [ZITADEL_ROLE_EMPLOYEE]: FULL_EDIT,
  [ZITADEL_ROLE_FREELANCER]: FULL_EDIT,
  [CLIENT_ADMIN]: FULL_EDIT,
  [CLIENT_PROJECT_MANAGER]: FULL_EDIT,
  [CLIENT_VIEWER]: CLIENT_VIEWER_PERMISSION,
  [ANONYMOUS]: [Permission.View_Objects, Permission.View_Measure],
  [FRONTEND_ONLY_DEMO]: [Permission.View_Objects, Permission.View_Measure,  Permission.View_Solar],
};

function getActualRoles() {
  const roles = store.getters.roles || [];
  const isEmployee = store.getters.activeUserIsEmployee;
  const isSampleProject = store.getters.isSampleProject;

  // Non-employees on sample projects are demoted to viewer-level (read-only).
  // Employees keep full edit on sample projects.
  if (isSampleProject && !isEmployee) return [CLIENT_VIEWER];

  const actualRoles = isEmployee ? [ZITADEL_ROLE_EMPLOYEE, ...roles] : [...roles];
  if (actualRoles.length === 0) actualRoles.push(ANONYMOUS);
  return actualRoles;
}

export function hasPermission(permission) {
  for (const role of getActualRoles()) {
    const perms = RolePermissions[role];
    if (perms && perms.includes(permission)) return true;
  }
  return false;
}
export function setAnonymousRole() {
  store.commit("setRoles", [ANONYMOUS]);
}

export function setFrontendOnlyDemoRole() {
  store.commit("setRoles", [FRONTEND_ONLY_DEMO]);
}
